import { render, staticRenderFns } from "./GridSocialIconsProviderBuilder.vue?vue&type=template&id=7ef1a956&"
import script from "./GridSocialIconsProviderBuilder.vue?vue&type=script&lang=js&"
export * from "./GridSocialIconsProviderBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports